export default function getStripePublishableKey() {
  if (window.location.origin === 'https://channels.org') {
    return 'pk_live_Jk1hPgkrP91huziSqFzRtt3S00uhszxDSV';
  }
  return 'pk_test_klga5DDgdOlU1FJxZZDq4vEp00lT5j5ozl';
}
